import { createFileRoute, Link } from '@tanstack/react-router'
import { contentWrapper } from '../../../../styles/contentWrapper'
import { titleWrapper, pageTitle, sectionWrapper, sectionTitle } from '../../../../styles/sectionStyles'
import ArrowBack from '~icons/material-symbols/arrow-back.svg'
import { TemplateDownloader } from './-components/template-downloader'
import { ReferenceListsDownloaderButton } from './-components/list-downloader'
import { Loader } from './-components/loader'
import { CsvErrorViewer } from './-components/error-viewer'
import { css } from '../../../../../styled-system/css'
import { Provider } from 'jotai'
import { ApplyChanges } from './-components/apply-changes'
import { Instructions } from './-components/instructions'

export const Route = createFileRoute('/admin/companies/bulkCreateCompanies/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Provider>
      <div className={contentWrapper()}>
      <div className={titleWrapper()}>
        <h1 className={pageTitle()}>
          <Link to='/admin/companies'>
            <ArrowBack />
          </Link>
          事業者・店舗一括登録
        </h1>
      </div>
      <div className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      })}>
        <div className={sectionWrapper()}>
          <div className={sectionTitle()}>テンプレートをダウンロード</div>
          <div className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          })}>
            <p>CSVファイルのテンプレートをダウンロードします。市区町村と店舗カテゴリは、市区町村リストとカテゴリーリストから選ぶ必要があります。</p>
            <div className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: '8px'
            })}>
              <TemplateDownloader />
              <ReferenceListsDownloaderButton />
            </div>
          </div>
        </div>
        <div className={sectionWrapper()}>
          <div className={sectionTitle()}>操作方法</div>
          <Instructions />
        </div>
        <div className={sectionWrapper()}>
          <div className={sectionTitle()}>データを読み込み</div>
          <Loader />
          <CsvErrorViewer />
        </div>
        <div className={sectionWrapper()}>
          <div className={sectionTitle()}>一括登録</div>
          <ApplyChanges />
        </div>
      </div>
      </div>
    </Provider>
  )
}
